/** @jsxImportSource @emotion/react */
import React from "react";
import { Amount } from "../../../../types/amount";
import { Token } from "../../../../store/global/TokenEnum";
import { ReactComponent as WarningIcon } from "../../../../img/trade-interface/warning_info.svg";
import { css } from "@emotion/react";
import { GlobalStore } from "../../../../store/global/GlobalStore";
import { Tooltip } from "components/general/Tooltip";

export const SpendLimitTooltip: React.FC<{
  isVisible?: boolean;
  currentAllowance: Amount;
  needed: Amount;
  symbol: Token;
}> = ({ currentAllowance, needed, symbol, isVisible = false }) => {
  const theme = GlobalStore.useState(s => s.theme);
  const tooltipContent = () => (
    <>
      <p>
        Approved spend limit: {currentAllowance.toString()} {symbol}
      </p>
      <p className="m-0">
        Total required: {needed.toString()} {symbol}
      </p>
    </>
  );

  if (!isVisible) {
    return null;
  }

  return (
    <div className="d-flex align-items-center" style={{ zIndex: 999999999999999 }}>
      <span
        className="me-2"
        css={css`
          color: ${theme["Colour ramps"].Yellow["400"]};
          font-family: ${theme.fontFamilies.Primary};
          font-weight: ${theme.fontWeights["work-sans-2"]};
          font-size: ${theme.fontSize["5"]};
        `}
      >
        Spend limit low{" "}
      </span>
      <Tooltip title={tooltipContent} style={{ zIndex: 10000000000000 }}>
        <WarningIcon width={14} height={14} className="me-3" />
      </Tooltip>
    </div>
  );
};
